export const API_D360_URL = '/ms/d360/api';

// Для локальной разработки фронт локал + бэк удаленный
// export const API_D360_URL = 'http://localhost:8000/api';
// export const API_D360_URL = `https://cloud-stage.kampus.local/ms/d360/api`;
